'use client';

import { createStack } from '@mui/system';
import styled from "../styles/styled.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
var Stack = createStack({
  createStyledComponent: styled('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  }),
  useThemeProps: function useThemeProps(inProps) {
    return useDefaultProps({
      props: inProps,
      name: 'MuiStack'
    });
  }
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Stack;